import React, { useState, useEffect } from 'react';
import { Modal, Form, Row, Col, Button as BootstrapButton, Card, Tabs, Tab, Table, Badge, Spinner, Nav, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { Formik, FieldArray } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { useMutation, useQueryClient } from 'react-query';
import { Post, Get, Put, DeleteSingle as Delete } from '@app/utils/httpProvider';
import { YEUCAU_THAYDOI_API, THAYDOI_DETAI_API, THAYDOI_CBHD_API, GIAHAN_DAOTAO_API, CHITIET_THAYDOI_CBHD_API, BaseGatewayImage, DANHGIA_DETAI_API, DANHGIA_CBHD_API, DANHGIA_GIAHAN_API } from '@app/utils/apiUrl';
import { objectLoaiYeuCau, loaiYeuCauValue, trangThaiYeuCauValue, messageToast, objectLoaiCanBoHuongDan, loaiCanBoHuongDanValue, trangThaiGuiKetQuaValue } from '@app/utils/define';
import DocumentInput from '@app/components/document-input/DocumentInput';
import DanhGiaDeTaiForm from '../quanLyHoSoNCS/DanhGiaDeTaiForm';
import DanhGiaCBHDForm from '../quanLyHoSoNCS/DanhGiaCBHDForm';
import DanhGiaGiaHanForm from '../quanLyHoSoNCS/DanhGiaGiaHanForm';

const customSelectStyles = {
    control: (base, state) => ({
        ...base,
        backgroundColor: state.isDisabled ? '#ffffff' : '#ffffff',
    }),
    singleValue: (base, state) => ({
        ...base,
        color: state.isDisabled ? '#495057' : base.color,
    })
};

const FieldDisplayFile = ({ label, value }) => {
    const getSafeUrl = (path) => {
        if (!path) return null;
        if (path.startsWith('http')) return path;
        const baseUrl = BaseGatewayImage.endsWith('/') ? BaseGatewayImage.slice(0, -1) : BaseGatewayImage;
        const safePath = path.startsWith('/') ? path : `/${path}`;
        return `${baseUrl}${safePath}`;
    };

    let files = [];
    if (value) {
        try {
            const parsed = JSON.parse(value);
            if (Array.isArray(parsed)) {
                files = parsed;
            } else {
                files = [{ filePath: value, name: value.split('/').pop() }];
            }
        } catch (e) {
            files = [{ filePath: value, name: value.split('/').pop() }];
        }
    }

    return (
        <Form.Group className="mb-3">
            {label && <Form.Label className="font-weight-bold text-muted small d-block">{label}</Form.Label>}
            <div className="d-flex flex-wrap">
                {files.length > 0 ? (
                    files.map((file, idx) => {
                        const path = file.filePath || file;
                        let name = file.name || (typeof path === 'string' ? path.split('/').pop() : 'File');
                        name = name.replace(/_\d{14}(?=\.\w+$|$)/, '');
                        return (
                            <a key={idx} href={getSafeUrl(path)} target="_blank" rel="noreferrer" className={`btn btn-outline-primary text-left ${label ? '' : 'btn-sm'} mb-1 mr-1`} style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' }} title={name}>
                                <i className="fas fa-paperclip mr-1"></i> {name}
                            </a>
                        );
                    })
                ) : (
                    <div className={label ? "d-flex align-items-center" : ""} style={label ? { height: '38px' } : {}}>
                        <span className="text-muted small">Không có file đính kèm</span>
                    </div>
                )}
            </div>
        </Form.Group>
    );
};
import Select from 'react-select';
import { userManager } from '@app/utils/oidc';
import moment from 'moment';
import { ConfirmModal } from '../../../../modules/modal/ConfirmModal';

import { useParams, useHistory } from 'react-router-dom';

const baseSchema = yup.object().shape({
    loaiYeuCau: yup.string().nullable().required('Vui lòng chọn loại yêu cầu thay đổi')
});

const FormWrapper = ({ isModal, show, onHide, title, children }) => {
    if (isModal) {
        return (
            <Modal show={show} onHide={onHide} size="lg" backdrop="static">
                <Modal.Header closeButton className="bg-info text-white">
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0 custom-modal-body" style={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto', overflowX: 'hidden' }}>
                    {children}
                </Modal.Body>
            </Modal>
        );
    }
    return <>{children}</>;
};

const YeuCauThayDoi = () => {
    const { id: hoSoId } = useParams();
    const history = useHistory();
    const [accountId, setAccountId] = useState('');
    const [danhSachYeuCau, setDanhSachYeuCau] = useState([]);
    const [loadingList, setLoadingList] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [viewMode, setViewMode] = useState('create');
    const [showModal, setShowModal] = useState(false);

    // Confirm Modal states
    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    
    const [openConfirmSendModal, setOpenConfirmSendModal] = useState(false);
    const [itemToSend, setItemToSend] = useState(null);
    const queryClient = useQueryClient();
    const [selectedRow, setSelectedRow] = useState(null);

    const fetchDanhSachYeuCau = async () => {
        if (!hoSoId) return;
        setLoadingList(true);
        try {
            const res = await Get(`${YEUCAU_THAYDOI_API.GET_PAGING}?HoSoNghienCuuSinhId=${hoSoId}&PageIndex=1&PageSize=20`);
            if (res && res.data) {
                // Lấy thông tin trạng thái từ bảng chi tiết tương ứng
                const details = await Promise.all(res.data.map(async (item) => {
                    let detailInfo = null;
                    try {
                        if (item.loaiYeuCau === loaiYeuCauValue.thayDoiDeTai) {
                            detailInfo = await Get(`${THAYDOI_DETAI_API.GET_BY_YEUCAU_ID}/${item.id || item.Id}`);
                        } else if (item.loaiYeuCau === loaiYeuCauValue.thayDoiCBHD) {
                            detailInfo = await Get(`${THAYDOI_CBHD_API.GET_BY_YEUCAU_ID}/${item.id || item.Id}`);
                        } else if (item.loaiYeuCau === loaiYeuCauValue.giaHanDaoTao) {
                            detailInfo = await Get(`${GIAHAN_DAOTAO_API.GET_BY_YEUCAU_ID}/${item.id || item.Id}`);
                        }
                    } catch (e) {
                        console.error("Error fetching detail", e);
                    }
                    
                    return {
                        ...item,
                        chiTietId: detailInfo?.id || detailInfo?.Id || null,
                        trangThaiYeuCau: detailInfo?.trangThaiYeuCau !== undefined ? detailInfo.trangThaiYeuCau : (detailInfo?.TrangThaiYeuCau !== undefined ? detailInfo.TrangThaiYeuCau : null),
                        detailInfo: detailInfo
                    };
                }));
                setDanhSachYeuCau(details);
            }
        } catch (error) {
            console.error("Error fetching list:", error);
            toast.error("Không thể tải danh sách yêu cầu.");
        } finally {
            setLoadingList(false);
        }
    };

    useEffect(() => {
        if (hoSoId) {
            fetchDanhSachYeuCau();
            const fetchInfo = async () => {
                const user = await userManager.getUser();
                const accId = user?.profile?.sub || null;
                if (accId) setAccountId(accId);
            };
            fetchInfo();
        }
    }, [hoSoId]);

    useEffect(() => {
        if (danhSachYeuCau && danhSachYeuCau.length > 0) {
            setSelectedRow(prev => {
                if (prev) {
                    const fresh = danhSachYeuCau.find(item => (item.id || item.Id) === (prev.id || prev.Id));
                    return fresh || danhSachYeuCau[0];
                }
                return danhSachYeuCau[0];
            });
        } else {
            setSelectedRow(null);
        }
    }, [danhSachYeuCau]);

    const triggerDeleteYeuCau = (yeuCauId, chiTietId, loaiYeuCau) => {
        setItemToDelete({ yeuCauId, chiTietId, loaiYeuCau });
        setOpenConfirmDeleteModal(true);
    };

    const handleDeleteYeuCau = async () => {
        if (!itemToDelete) return;
        const { yeuCauId, chiTietId, loaiYeuCau } = itemToDelete;
        setOpenConfirmDeleteModal(false);
        
        try {
            // Delete detail first
            if (chiTietId) {
                if (loaiYeuCau === loaiYeuCauValue.thayDoiDeTai) {
                    await Delete(THAYDOI_DETAI_API.DELETE_ITEM, chiTietId);
                } else if (loaiYeuCau === loaiYeuCauValue.thayDoiCBHD) {
                    await Delete(THAYDOI_CBHD_API.DELETE_ITEM, chiTietId);
                } else if (loaiYeuCau === loaiYeuCauValue.giaHanDaoTao) {
                    await Delete(GIAHAN_DAOTAO_API.DELETE_ITEM, chiTietId);
                }
            }
            // Delete main request
            const res = await Delete(YEUCAU_THAYDOI_API.DELETE_ITEM, yeuCauId);
            if (res && res.ok) {
                toast.success(messageToast.messageToastDeleteSuccess);
                fetchDanhSachYeuCau();
                queryClient.invalidateQueries(['duyetThayDoi']);
                queryClient.invalidateQueries(['yeuCauThayDoiData']);
                if (onSuccess) onSuccess();
            } else {
                toast.error(messageToast.messageToastDeleteError);
            }
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(messageToast.messageToastTryCatch);
        }
    };

    const triggerSendYeuCau = (chiTietId, loaiYeuCau) => {
        setItemToSend({ chiTietId, loaiYeuCau });
        setOpenConfirmSendModal(true);
    };

    const handleSendYeuCau = async () => {
        if (!itemToSend) return;
        const { chiTietId, loaiYeuCau } = itemToSend;
        setOpenConfirmSendModal(false);
        
        try {
            let res = null;
            // Fetch current item to update its status
            if (loaiYeuCau === loaiYeuCauValue.thayDoiDeTai) {
                const item = await Get(`${THAYDOI_DETAI_API.GET_ITEM}/${chiTietId}`);
                if (item) {
                    item.trangThaiYeuCau = 1; // dangXuLy
                    res = await Put(THAYDOI_DETAI_API.UPDATE_ITEM, chiTietId, item);
                }
            } else if (loaiYeuCau === loaiYeuCauValue.thayDoiCBHD) {
                const item = await Get(`${THAYDOI_CBHD_API.GET_ITEM}/${chiTietId}`);
                if (item) {
                    item.trangThaiYeuCau = 1; // dangXuLy
                    res = await Put(THAYDOI_CBHD_API.UPDATE_ITEM, chiTietId, item);
                }
            } else if (loaiYeuCau === loaiYeuCauValue.giaHanDaoTao) {
                const item = await Get(`${GIAHAN_DAOTAO_API.GET_ITEM}/${chiTietId}`);
                if (item) {
                    item.trangThaiYeuCau = 1; // dangXuLy
                    res = await Put(GIAHAN_DAOTAO_API.UPDATE_ITEM, chiTietId, item);
                }
            }
            
            if (res) {
                toast.success("Gửi yêu cầu thành công!");
                fetchDanhSachYeuCau();
                queryClient.invalidateQueries(['duyetThayDoi']);
                queryClient.invalidateQueries(['yeuCauThayDoiData']);
                if (onSuccess) onSuccess();
            } else {
                toast.error("Không thể gửi yêu cầu.");
            }
        } catch (error) {
            console.error("Send error:", error);
            toast.error(messageToast.messageToastTryCatch);
        }
    };

    const getEnumValue = (value, valueMap) => {
        if (value === null || value === undefined || value === '') return value;
        if (typeof value === 'number') return value;
        if (typeof value === 'string' && valueMap) {
            if (valueMap[value] !== undefined) return valueMap[value];
            const camelCase = value.charAt(0).toLowerCase() + value.slice(1);
            if (valueMap[camelCase] !== undefined) return valueMap[camelCase];
            const matchKey = Object.keys(valueMap).find(k => k.toLowerCase() === value.toLowerCase());
            if (matchKey) return valueMap[matchKey];
            if (!isNaN(value)) return parseInt(value);
        }
        return value;
    };

    const handleView = async (item) => {
        let chiTiets = [];
        let danhGiaDeTaiData = null;
        let danhGiaCBHDData = null;
        
        if (item.loaiYeuCau === loaiYeuCauValue.thayDoiDeTai && item.chiTietId) {
            try {
                const res = await Get(`${DANHGIA_DETAI_API.GET_BY_THAYDOI_ID}/${item.chiTietId}`);
                if (res && res.data) {
                    danhGiaDeTaiData = res.data;
                } else if (res) {
                    danhGiaDeTaiData = res;
                }
            } catch (e) {
                console.error("Lỗi lấy đánh giá đề tài", e);
            }
        }
        
        if (item.loaiYeuCau === loaiYeuCauValue.thayDoiCBHD && item.chiTietId) {
            try {
                const resDanhGia = await Get(`${DANHGIA_CBHD_API.GET_BY_THAYDOI_ID}/${item.chiTietId}`);
                if (resDanhGia && resDanhGia.data) {
                    danhGiaCBHDData = resDanhGia.data;
                } else if (resDanhGia) {
                    danhGiaCBHDData = resDanhGia;
                }
            } catch (e) {
                console.error("Lỗi lấy đánh giá CBHD", e);
            }

            try {
                const res = await Get(`${CHITIET_THAYDOI_CBHD_API.GET_BY_THAYDOI_ID}/${item.chiTietId}`);
                if (res) {
                    const rawData = res.data || res;
                    chiTiets = rawData.$values || rawData;
                    if (!Array.isArray(chiTiets)) chiTiets = [];
                    const customLoaiCanBoMap = { ...loaiCanBoHuongDanValue, canBoHuongDanChinh: 0, canBoHuongDanPhu: 1, dongHuongDan: 2 };
                    chiTiets = chiTiets.map(ct => ({
                        ...ct,
                        loaiCanBoHuongDan: getEnumValue(ct.loaiCanBoHuongDan, customLoaiCanBoMap)
                    }));
                }
            } catch (e) {
                console.error("Lỗi lấy chi tiết CBHD", e);
            }
        }

        let danhGiaGiaHanData = null;
        if (item.loaiYeuCau === loaiYeuCauValue.giaHanDaoTao && item.chiTietId) {
            try {
                const resDanhGia = await Get(`${DANHGIA_GIAHAN_API.GET_BY_THAYDOI_ID}/${item.chiTietId}`);
                if (resDanhGia && resDanhGia.data) {
                    danhGiaGiaHanData = resDanhGia.data;
                } else if (resDanhGia) {
                    danhGiaGiaHanData = resDanhGia;
                }
            } catch (e) {
                console.error("Lỗi lấy đánh giá Gia hạn", e);
            }
        }
        
        setSelectedItem({ ...item, chiTietThayDoiCBHDs: chiTiets, danhGiaDeTaiData: danhGiaDeTaiData, danhGiaCBHDData: danhGiaCBHDData, danhGiaGiaHanData: danhGiaGiaHanData });
        setViewMode('view');
        setShowModal(true);
    };

    const handleEdit = async (item) => {
        let chiTiets = [];
        if (item.loaiYeuCau === loaiYeuCauValue.thayDoiCBHD && item.chiTietId) {
            try {
                const res = await Get(`${CHITIET_THAYDOI_CBHD_API.GET_BY_THAYDOI_ID}/${item.chiTietId}`);
                if (res) {
                    const rawData = res.data || res;
                    chiTiets = rawData.$values || rawData;
                    if (!Array.isArray(chiTiets)) chiTiets = [];
                    const customLoaiCanBoMap = { ...loaiCanBoHuongDanValue, canBoHuongDanChinh: 0, canBoHuongDanPhu: 1, dongHuongDan: 2 };
                    chiTiets = chiTiets.map(ct => ({
                        ...ct,
                        loaiCanBoHuongDan: getEnumValue(ct.loaiCanBoHuongDan, customLoaiCanBoMap)
                    }));
                }
            } catch (e) {
                console.error("Lỗi lấy chi tiết CBHD", e);
            }
        }
        setSelectedItem({ ...item, chiTietThayDoiCBHDs: chiTiets });
        setViewMode('edit');
        setShowModal(true);
    };

    const mutationCreateYeuCau = useMutation((data) => Post(YEUCAU_THAYDOI_API.CREATE, null, data));
    const mutationCreateThayDoiDeTai = useMutation((data) => Post(THAYDOI_DETAI_API.CREATE, null, data));
    const mutationCreateThayDoiCBHD = useMutation((data) => Post(THAYDOI_CBHD_API.CREATE, null, data));
    const mutationCreateGiaHanDaoTao = useMutation((data) => Post(GIAHAN_DAOTAO_API.CREATE, null, data));
    const mutationCreateChiTietThayDoiCBHD = useMutation((data) => Post(CHITIET_THAYDOI_CBHD_API.CREATE, null, data));

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            if (viewMode === 'edit') {
                const chiTietId = selectedItem?.chiTietId;
                if (!chiTietId) throw new Error('Không tìm thấy ID chi tiết');

                if (values.loaiYeuCau === loaiYeuCauValue.thayDoiDeTai) {
                    const deTaiData = {
                        ...selectedItem.detailInfo,
                        lyDoThayDoi: values.lyDoThayDoi,
                        tenDeTaiDuKien: values.tenDeTaiDuKien,
                        fileYKienCBHD: values.fileYKienCBHD,
                        fileMinhChungDeTai: values.fileMinhChungDeTai,
                        ngayThongQua: values.ngayThongQua || null
                    };
                    await Put(THAYDOI_DETAI_API.UPDATE_ITEM, chiTietId, deTaiData);
                } else if (values.loaiYeuCau === loaiYeuCauValue.thayDoiCBHD) {
                    const cbhdData = {
                        ...selectedItem.detailInfo,
                        lyDoThayDoi: values.lyDoThayDoi,
                        fileYKienCBHD: values.fileYKienCBHD
                    };
                    await Put(THAYDOI_CBHD_API.UPDATE_ITEM, chiTietId, cbhdData);
                    
                    const oldChiTiets = selectedItem.chiTietThayDoiCBHDs || [];
                    const newChiTiets = values.chiTietThayDoiCBHDs || [];
                    
                    const removedChiTiets = oldChiTiets.filter(o => !newChiTiets.find(n => (n.id || n.Id) === (o.id || o.Id)));
                    for (const rm of removedChiTiets) {
                        await Delete(CHITIET_THAYDOI_CBHD_API.DELETE_ITEM, rm.id || rm.Id);
                    }
                    
                    for (const item of newChiTiets) {
                        const chiTietData = {
                            thayDoiCBHDId: chiTietId,
                            hoTen: item.hoTen,
                            loaiCanBoHuongDan: item.loaiCanBoHuongDan,
                            donViCongTac: item.donViCongTac,
                            fileLyLichKhoaHoc: item.fileLyLichKhoaHoc,
                            fileMinhChung: item.fileMinhChung
                        };
                        const itemId = item.id || item.Id;
                        if (itemId) {
                            await Put(CHITIET_THAYDOI_CBHD_API.UPDATE_ITEM, itemId, { ...chiTietData, id: itemId, Id: itemId });
                        } else {
                            await mutationCreateChiTietThayDoiCBHD.mutateAsync(chiTietData);
                        }
                    }
                } else if (values.loaiYeuCau === loaiYeuCauValue.giaHanDaoTao) {
                    const giaHanData = {
                        ...selectedItem.detailInfo,
                        thoiGianGiaHan: parseInt(values.thoiGianGiaHan, 10),
                        fileCongVan: values.fileCongVan,
                        fileBaoCao: values.fileBaoCao
                    };
                    await Put(GIAHAN_DAOTAO_API.UPDATE_ITEM, chiTietId, giaHanData);
                }

                toast.success("Cập nhật yêu cầu thay đổi thành công!");
                fetchDanhSachYeuCau();
                queryClient.invalidateQueries(['duyetThayDoi']);
                queryClient.invalidateQueries(['yeuCauThayDoiData']);
                setShowModal(false);
                setSelectedItem(null);
                if (onSuccess) onSuccess();
                return;
            }

            // Bước 1: Tạo YeuCauThayDoi
            const yeuCauData = {
                accountId: accountId,
                hoSoNghienCuuSinhId: hoSoId,
                loaiYeuCau: values.loaiYeuCau
            };

            const yeuCauRes = await mutationCreateYeuCau.mutateAsync(yeuCauData);

            let yeuCauId = null;
            if (yeuCauRes && yeuCauRes.ok) {
                try {
                    const data = await yeuCauRes.json();
                    yeuCauId = data.id || data.data?.id;
                } catch (e) { }
            }

            if (yeuCauId) {
                // Bước 2: Tạo ChiTiet dựa vào loại yêu cầu
                if (values.loaiYeuCau === loaiYeuCauValue.thayDoiDeTai) {
                    const deTaiData = {
                        yeuCauThayDoiId: yeuCauId,
                        lyDoThayDoi: values.lyDoThayDoi,
                        tenDeTaiDuKien: values.tenDeTaiDuKien,
                        fileYKienCBHD: values.fileYKienCBHD,
                        fileMinhChungDeTai: values.fileMinhChungDeTai,
                        ngayThongQua: values.ngayThongQua || null,
                        trangThaiYeuCau: trangThaiYeuCauValue.choGui
                    };
                    await mutationCreateThayDoiDeTai.mutateAsync(deTaiData);
                } else if (values.loaiYeuCau === loaiYeuCauValue.thayDoiCBHD) {
                    const cbhdData = {
                        yeuCauThayDoiId: yeuCauId,
                        lyDoThayDoi: values.lyDoThayDoi,
                        fileYKienCBHD: values.fileYKienCBHD,
                        trangThaiYeuCau: trangThaiYeuCauValue.choGui
                    };
                    const thayDoiCBHDRes = await mutationCreateThayDoiCBHD.mutateAsync(cbhdData);
                    
                    let thayDoiCBHDId = null;
                    if (thayDoiCBHDRes && thayDoiCBHDRes.ok) {
                        try {
                            const data = await thayDoiCBHDRes.json();
                            thayDoiCBHDId = data.id || data.data?.id;
                        } catch (e) { }
                    }

                    if (thayDoiCBHDId && values.chiTietThayDoiCBHDs && values.chiTietThayDoiCBHDs.length > 0) {
                        for (const item of values.chiTietThayDoiCBHDs) {
                            const chiTietData = {
                                thayDoiCBHDId: thayDoiCBHDId,
                                hoTen: item.hoTen,
                                loaiCanBoHuongDan: item.loaiCanBoHuongDan,
                                donViCongTac: item.donViCongTac,
                                fileLyLichKhoaHoc: item.fileLyLichKhoaHoc,
                                fileMinhChung: item.fileMinhChung
                            };
                            await mutationCreateChiTietThayDoiCBHD.mutateAsync(chiTietData);
                        }
                    }
                } else if (values.loaiYeuCau === loaiYeuCauValue.giaHanDaoTao) {
                    const giaHanData = {
                        yeuCauThayDoiId: yeuCauId,
                        thoiGianGiaHan: parseInt(values.thoiGianGiaHan, 10),
                        fileCongVan: values.fileCongVan,
                        fileBaoCao: values.fileBaoCao,
                        trangThaiYeuCau: trangThaiYeuCauValue.choGui
                    };
                    await mutationCreateGiaHanDaoTao.mutateAsync(giaHanData);
                }

                toast.success(messageToast.messageToastCreateSuccess);
                resetForm();
                fetchDanhSachYeuCau();
                queryClient.invalidateQueries(['duyetThayDoi']);
                queryClient.invalidateQueries(['yeuCauThayDoiData']);
                setShowModal(false);
                if (onSuccess) onSuccess();
            } else {
                toast.error(messageToast.messageToastCreateError);
            }
        } catch (error) {
            console.error('Lỗi khi lưu yêu cầu thay đổi:', error);
            toast.error(messageToast.messageToastTryCatch);
        } finally {
            setSubmitting(false);
        }
    };

    const renderBadge = (status) => {
        switch (status) {
            case 1:
            case trangThaiYeuCauValue.dangXuLy: return <Badge variant="primary">Đang xử lý</Badge>;
            case 2:
            case trangThaiYeuCauValue.boSung: return <Badge variant="warning">Yêu cầu bổ sung</Badge>;
            case 3:
            case trangThaiYeuCauValue.hoanThanh: return <Badge variant="success">Hoàn thành</Badge>;
            case 4:
            case trangThaiYeuCauValue.tuChoi: return <Badge variant="danger">Từ chối</Badge>;
            case 0:
            case trangThaiYeuCauValue.choGui:
            default: return <Badge variant="secondary">Chờ gửi</Badge>;
        }
    };

    const getLoaiYeuCauText = (val) => {
        const found = objectLoaiYeuCau.find(x => x.value === val);
        return found ? found.label : '';
    };

    const onSuccess = () => {}; 

    const handleClose = () => {
        if (showModal) {
            setShowModal(false);
            setSelectedItem(null);
        } else {
            history.goBack();
        }
    };

    return (
        <div className="container-fluid">
            <Card className="card-layout-full">
                <Card.Header>
                    <div className="d-flex justify-content-between align-items-center">
                        <h4 className="mb-0">Danh sách yêu cầu thay đổi</h4>
                        <BootstrapButton variant="success" onClick={() => { setViewMode('create'); setSelectedItem(null); setShowModal(true); }}>
                            <i className="fas fa-plus mr-1"></i> Tạo yêu cầu
                        </BootstrapButton>
                    </div>
                </Card.Header>
                <Card.Body className="d-flex flex-column p-0">
                
                <div className="table-responsive flex-grow-1 p-3">
                        {loadingList ? (
                            <div className="text-center py-4">
                                <Spinner animation="border" variant="primary" />
                            </div>
                        ) : (
                            <Table striped bordered hover responsive size="sm">
                                <thead>
                                    <tr>
                                        <th className="text-center" width="50">STT</th>
                                        <th>Loại yêu cầu</th>
                                        <th className="text-center">Ngày tạo</th>
                                        <th className="text-center">Trạng thái</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {danhSachYeuCau.length > 0 ? (
                                        danhSachYeuCau.map((item, index) => {
                                            const ghiChu = item.detailInfo?.ghiChuChinhSua || item.detailInfo?.GhiChuChinhSua;
                                            
                                            let noteColor = '#b45309';
                                            let noteBgColor = '#fffbeb';
                                            let noteBorderColor = '#f59e0b';
                                            let iconClass = 'fa-exclamation-circle';

                                            if (item.trangThaiYeuCau === 3 || item.trangThaiYeuCau === trangThaiYeuCauValue.hoanThanh) {
                                                noteColor = '#065f46';
                                                noteBgColor = '#ecfdf5';
                                                noteBorderColor = '#10b981';
                                                iconClass = 'fa-check-circle';
                                            } else if (item.trangThaiYeuCau === 4 || item.trangThaiYeuCau === trangThaiYeuCauValue.tuChoi) {
                                                noteColor = '#991b1b';
                                                noteBgColor = '#fef2f2';
                                                noteBorderColor = '#ef4444';
                                                iconClass = 'fa-times-circle';
                                            }

                                            return (
                                                <React.Fragment key={item.id || item.Id}>
                                                    <tr 
                                                        onClick={() => setSelectedRow(item)}
                                                        className={selectedRow && (selectedRow.id || selectedRow.Id) === (item.id || item.Id) ? 'table-primary' : ''}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <td className="text-center">{index + 1}</td>
                                                        <td>{getLoaiYeuCauText(item.loaiYeuCau)}</td>
                                                        <td className="text-center">{item.createdDate ? moment(item.createdDate).format('DD/MM/YYYY HH:mm') : ''}</td>
                                                        <td className="text-center">{renderBadge(item.trangThaiYeuCau)}</td>
                                                    </tr>
                                                    {!!(ghiChu?.trim()) && (
                                                        <tr>
                                                            <td colSpan={4} className="p-0 border-0">
                                                                <div className="mx-3 mb-3 mt-2 p-3 rounded" style={{ borderLeft: `4px solid ${noteBorderColor}`, backgroundColor: noteBgColor }}>
                                                                    <div className="d-flex align-items-start">
                                                                        <i className={`fas ${iconClass} mt-1 mr-2`} style={{ fontSize: '1.2rem', color: noteBorderColor }}></i>
                                                                        <div>
                                                                            <strong style={{ color: noteColor }}>Phản hồi từ cán bộ duyệt: </strong>
                                                                            <span style={{ color: noteColor, whiteSpace: 'pre-wrap' }}>{ghiChu}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </React.Fragment>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="4" className="text-center">Chưa có yêu cầu nào</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        )}
                    </div>
                </Card.Body>
                {!loadingList && (
                    <Card.Footer className="bg-white card-footer-sticky">
                        <div className="d-flex justify-content-end pr-4">
                            <BootstrapButton 
                                variant="info" 
                                size="sm" 
                                className="mr-2"
                                onClick={() => handleView(selectedRow)}
                                disabled={!selectedRow}
                            >
                                <i className="fa fa-eye mr-1"></i> Xem chi tiết
                            </BootstrapButton>
                            <BootstrapButton 
                                variant="warning" 
                                size="sm" 
                                className="mr-2 text-white"
                                onClick={() => handleEdit(selectedRow)}
                                disabled={!selectedRow || (selectedRow.trangThaiYeuCau !== trangThaiYeuCauValue.choGui && selectedRow.trangThaiYeuCau !== trangThaiYeuCauValue.boSung)}
                            >
                                <i className="fa fa-edit mr-1"></i> Sửa
                            </BootstrapButton>
                            <BootstrapButton 
                                variant="success" 
                                size="sm" 
                                className="mr-2"
                                onClick={() => triggerSendYeuCau(selectedRow?.chiTietId, selectedRow?.loaiYeuCau)}
                                disabled={!selectedRow || (selectedRow.trangThaiYeuCau !== trangThaiYeuCauValue.choGui && selectedRow.trangThaiYeuCau !== trangThaiYeuCauValue.boSung)}
                            >
                                <i className="fas fa-paper-plane mr-1"></i> Gửi yêu cầu
                            </BootstrapButton>
                            <BootstrapButton 
                                variant="danger" 
                                size="sm" 
                                onClick={() => triggerDeleteYeuCau(selectedRow?.id || selectedRow?.Id, selectedRow?.chiTietId, selectedRow?.loaiYeuCau)}
                                disabled={!selectedRow || (selectedRow.trangThaiYeuCau !== trangThaiYeuCauValue.choGui && selectedRow.trangThaiYeuCau !== trangThaiYeuCauValue.boSung && selectedRow.trangThaiYeuCau != null)}
                            >
                                <i className="fas fa-trash mr-1"></i> Xóa
                            </BootstrapButton>
                        </div>
                    </Card.Footer>
                )}
                
                {showModal && (
                    <FormWrapper 
                        isModal={true} 
                        show={showModal} 
                        onHide={handleClose} 
                        title={viewMode === 'create' ? 'Tạo mới yêu cầu' : viewMode === 'edit' ? 'Cập nhật yêu cầu' : 'Chi tiết yêu cầu'}
                    >
                    <Formik
                        enableReinitialize
                        initialValues={selectedItem ? {
                            loaiYeuCau: selectedItem.loaiYeuCau,
                            lyDoThayDoi: selectedItem.detailInfo?.lyDoThayDoi || '',
                            tenDeTaiDuKien: selectedItem.detailInfo?.tenDeTaiDuKien || '',
                            fileYKienCBHD: selectedItem.detailInfo?.fileYKienCBHD || '',
                            fileMinhChungDeTai: selectedItem.detailInfo?.fileMinhChungDeTai || '',
                            ngayThongQua: selectedItem.detailInfo?.ngayThongQua ? moment(selectedItem.detailInfo.ngayThongQua).format('YYYY-MM-DD') : '',
                            thoiGianGiaHan: selectedItem.detailInfo?.thoiGianGiaHan || '',
                            fileCongVan: selectedItem.detailInfo?.fileCongVan || '',
                            fileBaoCao: selectedItem.detailInfo?.fileBaoCao || '',
                            chiTietThayDoiCBHDs: selectedItem.chiTietThayDoiCBHDs && selectedItem.chiTietThayDoiCBHDs.length > 0 ? selectedItem.chiTietThayDoiCBHDs : [
                                { hoTen: '', loaiCanBoHuongDan: null, donViCongTac: '', fileLyLichKhoaHoc: '', fileMinhChung: '' }
                            ]
                        } : {
                            loaiYeuCau: null,
                            lyDoThayDoi: '',
                            tenDeTaiDuKien: '',
                            fileYKienCBHD: '',
                            fileMinhChungDeTai: '',
                            ngayThongQua: '',
                            thoiGianGiaHan: '',
                            fileCongVan: '',
                            fileBaoCao: '',
                            chiTietThayDoiCBHDs: [
                                { hoTen: '', loaiCanBoHuongDan: null, donViCongTac: '', fileLyLichKhoaHoc: '', fileMinhChung: '' }
                            ]
                        }}
                validationSchema={
                    baseSchema.shape({
                        tenDeTaiDuKien: yup.string().nullable().when('loaiYeuCau', {
                            is: (val) => val === loaiYeuCauValue.thayDoiDeTai,
                            then: yup.string().required('Vui lòng nhập tên đề tài dự kiến').max(1000, 'Tối đa 1000 ký tự')
                        }),
                        lyDoThayDoi: yup.string().nullable().when('loaiYeuCau', {
                            is: (val) => val === loaiYeuCauValue.thayDoiDeTai || val === loaiYeuCauValue.thayDoiCBHD,
                            then: yup.string().required('Vui lòng nhập lý do thay đổi').max(2000, 'Tối đa 2000 ký tự')
                        }),
                        ngayThongQua: yup.string().nullable().when('loaiYeuCau', {
                            is: (val) => val === loaiYeuCauValue.thayDoiDeTai,
                            then: yup.string().required('Vui lòng nhập ngày dự kiến thông qua')
                        }),
                        fileYKienCBHD: yup.string().nullable().when('loaiYeuCau', {
                            is: (val) => val === loaiYeuCauValue.thayDoiDeTai || val === loaiYeuCauValue.thayDoiCBHD,
                            then: yup.string().required('Vui lòng đính kèm file ý kiến của CBHD')
                        }),
                        fileMinhChungDeTai: yup.string().nullable().when('loaiYeuCau', {
                            is: (val) => val === loaiYeuCauValue.thayDoiDeTai,
                            then: yup.string().required('Vui lòng đính kèm file minh chứng đề tài')
                        }),
                        thoiGianGiaHan: yup.number().nullable().when('loaiYeuCau', {
                            is: (val) => val === loaiYeuCauValue.giaHanDaoTao,
                            then: yup.number().required('Vui lòng nhập thời gian gia hạn').min(1, 'Thời gian gia hạn lớn hơn 0')
                        }),
                        fileCongVan: yup.string().nullable().when('loaiYeuCau', {
                            is: (val) => val === loaiYeuCauValue.giaHanDaoTao,
                            then: yup.string().required('Vui lòng đính kèm file công văn')
                        }),
                        fileBaoCao: yup.string().nullable().when('loaiYeuCau', {
                            is: (val) => val === loaiYeuCauValue.giaHanDaoTao,
                            then: yup.string().required('Vui lòng đính kèm file báo cáo')
                        }),
                        chiTietThayDoiCBHDs: yup.array().when('loaiYeuCau', {
                            is: (val) => val === loaiYeuCauValue.thayDoiCBHD,
                            then: yup.array().of(
                                yup.object().shape({
                                    hoTen: yup.string().required('Vui lòng nhập họ tên cán bộ'),
                                    loaiCanBoHuongDan: yup.number().nullable().required('Vui lòng chọn loại cán bộ'),
                                    donViCongTac: yup.string().required('Vui lòng nhập đơn vị công tác'),
                                    fileLyLichKhoaHoc: yup.string().required('Vui lòng đính kèm file lý lịch'),
                                    fileMinhChung: yup.string().required('Vui lòng đính kèm file minh chứng')
                                })
                            ).min(1, 'Vui lòng thêm ít nhất 1 cán bộ hướng dẫn'),
                            otherwise: yup.array().nullable()
                        })
                    })
                }
                onSubmit={handleSubmit}
            >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue, submitCount }) => {
                    const ghiChu = selectedItem?.detailInfo?.ghiChuChinhSua || selectedItem?.detailInfo?.GhiChuChinhSua;
                    let noteColor = '#b45309';
                    let noteBgColor = '#fffbeb';
                    let noteBorderColor = '#f59e0b';
                    let iconClass = 'fa-exclamation-circle';

                    if (selectedItem?.trangThaiYeuCau === 3 || selectedItem?.trangThaiYeuCau === trangThaiYeuCauValue.hoanThanh) {
                        noteColor = '#065f46';
                        noteBgColor = '#ecfdf5';
                        noteBorderColor = '#10b981';
                        iconClass = 'fa-check-circle';
                    } else if (selectedItem?.trangThaiYeuCau === 4 || selectedItem?.trangThaiYeuCau === trangThaiYeuCauValue.tuChoi) {
                        noteColor = '#991b1b';
                        noteBgColor = '#fef2f2';
                        noteBorderColor = '#ef4444';
                        iconClass = 'fa-times-circle';
                    }

                    const formContent = (
                        <div className="p-3">
                            {!!(ghiChu?.trim()) && (
                                <div className="alert mb-4 shadow-sm" style={{ backgroundColor: noteBgColor, borderLeft: `5px solid ${noteBorderColor}`, color: noteColor }}>
                                    <h6 className="alert-heading font-weight-bold mb-2">
                                        <i className={`fas ${iconClass} mr-2`} style={{ color: noteBorderColor }}></i> Phản hồi từ cán bộ duyệt:
                                    </h6>
                                    <p className="mb-0 ml-4" style={{ whiteSpace: 'pre-wrap', fontSize: '0.95rem' }}>
                                        {ghiChu}
                                    </p>
                                </div>
                            )}
                            <Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label>Loại yêu cầu thay đổi <span className="text-danger">*</span></Form.Label>
                                        <Select
                                            options={objectLoaiYeuCau}
                                            value={objectLoaiYeuCau.find((opt) => opt.value === values.loaiYeuCau) || null}
                                            onChange={(opt) => setFieldValue('loaiYeuCau', opt ? opt.value : null)}
                                            placeholder="Chọn loại yêu cầu"
                                            isClearable
                                            isDisabled={viewMode !== 'create'}
                                            styles={customSelectStyles}
                                        />
                                        {errors.loaiYeuCau && touched.loaiYeuCau && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.loaiYeuCau}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>

                            {values.loaiYeuCau === loaiYeuCauValue.thayDoiDeTai && (
                                <>
                                    <Row>
                                        <Col md={12}>
                                            <Form.Group>
                                                <Form.Label>Tên đề tài dự kiến <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="tenDeTaiDuKien"
                                                    value={values.tenDeTaiDuKien}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    placeholder="Nhập tên đề tài dự kiến"
                                                    disabled={viewMode === 'view'} className={viewMode === 'view' ? "bg-white" : ""}
                                                />
                                                {touched.tenDeTaiDuKien && !!errors.tenDeTaiDuKien && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.tenDeTaiDuKien}</div>}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <Form.Group>
                                                <Form.Label>Lý do thay đổi <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    name="lyDoThayDoi"
                                                    value={values.lyDoThayDoi}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    placeholder="Nhập lý do thay đổi"
                                                    disabled={viewMode === 'view'} className={viewMode === 'view' ? "bg-white" : ""}
                                                />
                                                {touched.lyDoThayDoi && !!errors.lyDoThayDoi && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.lyDoThayDoi}</div>}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <Form.Group>
                                                <Form.Label>Ngày dự kiến thông qua đề cương mới <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    name="ngayThongQua"
                                                    value={values.ngayThongQua || ''}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    className={viewMode === 'view' ? "shadow-none bg-white" : "shadow-none"}
                                                    disabled={viewMode === 'view'}
                                                />
                                                {touched.ngayThongQua && !!errors.ngayThongQua && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.ngayThongQua}</div>}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6} className="mb-3">
                                            {viewMode === 'view' ? (
                                                <FieldDisplayFile label={<span>File ý kiến của CBHD <span className="text-danger">*</span></span>} value={values.fileYKienCBHD} />
                                            ) : (
                                                <DocumentInput
                                                    labelTitle={<span>File ý kiến của CBHD <span className="text-danger">*</span></span>}
                                                    value={values.fileYKienCBHD}
                                                    onChangeProp={(url) => setFieldValue('fileYKienCBHD', url)}
                                                    readOnly={viewMode === 'view'}
                                                />
                                            )}
                                            {submitCount > 0 && errors.fileYKienCBHD && !values.fileYKienCBHD && (
                                                <div className="text-danger small mt-1">{errors.fileYKienCBHD}</div>
                                            )}
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            {viewMode === 'view' ? (
                                                <FieldDisplayFile label={<span>File minh chứng đề tài <span className="text-danger">*</span></span>} value={values.fileMinhChungDeTai} />
                                            ) : (
                                                <DocumentInput
                                                    labelTitle={<span>File minh chứng đề tài <span className="text-danger">*</span></span>}
                                                    value={values.fileMinhChungDeTai}
                                                    onChangeProp={(url) => setFieldValue('fileMinhChungDeTai', url)}
                                                    readOnly={viewMode === 'view'}
                                                />
                                            )}
                                            {submitCount > 0 && errors.fileMinhChungDeTai && !values.fileMinhChungDeTai && (
                                                <div className="text-danger small mt-1">{errors.fileMinhChungDeTai}</div>
                                            )}
                                        </Col>
                                    </Row>
                                </>
                            )}

                            {values.loaiYeuCau === loaiYeuCauValue.thayDoiCBHD && (
                                <>
                                    <Row>
                                        <Col md={12}>
                                            <Form.Group>
                                                <Form.Label>Lý do thay đổi <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    name="lyDoThayDoi"
                                                    value={values.lyDoThayDoi}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    placeholder="Nhập lý do thay đổi"
                                                    disabled={viewMode === 'view'} className={viewMode === 'view' ? "bg-white" : ""}
                                                />
                                                {touched.lyDoThayDoi && !!errors.lyDoThayDoi && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.lyDoThayDoi}</div>}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12} className="mb-3">
                                            {viewMode === 'view' ? (
                                                <FieldDisplayFile label={<span>File ý kiến của Cán bộ hướng dẫn <span className="text-danger">*</span></span>} value={values.fileYKienCBHD} />
                                            ) : (
                                                <DocumentInput
                                                    labelTitle={<span>File ý kiến của Cán bộ hướng dẫn <span className="text-danger">*</span></span>}
                                                    value={values.fileYKienCBHD}
                                                    onChangeProp={(url) => setFieldValue('fileYKienCBHD', url)}
                                                    readOnly={viewMode === 'view'}
                                                />
                                            )}
                                            {submitCount > 0 && errors.fileYKienCBHD && !values.fileYKienCBHD && (
                                                <div className="text-danger small mt-1">{errors.fileYKienCBHD}</div>
                                            )}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <FieldArray
                                                name="chiTietThayDoiCBHDs"
                                                render={arrayHelpers => (
                                                    <div>
                                                        <Form.Label className="font-weight-bold text-muted small">Danh sách Cán bộ hướng dẫn <span className="text-danger">*</span></Form.Label>
                                                        {typeof errors.chiTietThayDoiCBHDs === 'string' && (
                                                            <div className="text-danger mb-2" style={{ fontSize: '13px' }}>{errors.chiTietThayDoiCBHDs}</div>
                                                        )}
                                                        {values.chiTietThayDoiCBHDs && values.chiTietThayDoiCBHDs.length > 0 ? (
                                                            values.chiTietThayDoiCBHDs.map((cbhd, index) => {
                                                                const errorObj = (errors.chiTietThayDoiCBHDs && errors.chiTietThayDoiCBHDs[index]) || {};
                                                                const touchedObj = (touched.chiTietThayDoiCBHDs && touched.chiTietThayDoiCBHDs[index]) || {};
                                                                
                                                                return (
                                                                    <div key={index} className="border p-3 mb-3 bg-white rounded position-relative">
                                                                        <h6 className="font-weight-bold mb-3 text-danger">Cán bộ hướng dẫn {index + 1}</h6>
                                                                        {viewMode !== 'view' && (
                                                                            <div className="position-absolute" style={{ top: '10px', right: '10px', zIndex: 10 }}>
                                                                                <BootstrapButton type="button" variant="outline-danger" size="sm" onClick={() => arrayHelpers.remove(index)} title="Xóa cán bộ hướng dẫn">
                                                                                    <i className="fas fa-trash"></i>
                                                                                </BootstrapButton>
                                                                            </div>
                                                                        )}
                                                                        <Row>
                                                                                <Col md={6}>
                                                                                    <Form.Group>
                                                                                        <Form.Label>Họ và tên <span className="text-danger">*</span></Form.Label>
                                                                                        <Form.Control
                                                                                            type="text"
                                                                                            name={`chiTietThayDoiCBHDs.${index}.hoTen`}
                                                                                            value={cbhd.hoTen}
                                                                                            onChange={handleChange}
                                                                                            onBlur={handleBlur}
                                                                                            placeholder="Nhập họ tên"
                                                                                            disabled={viewMode === 'view'} className={viewMode === 'view' ? "bg-white" : ""}
                                                                                        />
                                                                                        {touchedObj.hoTen && !!errorObj.hoTen && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errorObj.hoTen}</div>}
                                                                                    </Form.Group>
                                                                                </Col>
                                                                                <Col md={6}>
                                                                                    <Form.Group>
                                                                                        <Form.Label>Loại cán bộ hướng dẫn <span className="text-danger">*</span></Form.Label>
                                                                                        <Select
                                                                                            options={objectLoaiCanBoHuongDan}
                                                                                            value={objectLoaiCanBoHuongDan.find((opt) => opt.value === cbhd.loaiCanBoHuongDan) || null}
                                                                                            onChange={(opt) => setFieldValue(`chiTietThayDoiCBHDs.${index}.loaiCanBoHuongDan`, opt ? opt.value : null)}
                                                                                            placeholder="Chọn loại cán bộ"
                                                                                            isClearable
                                                                                            isDisabled={viewMode === 'view'}
                                                                                            styles={customSelectStyles}
                                                                                        />
                                                                                        {touchedObj.loaiCanBoHuongDan && errorObj.loaiCanBoHuongDan && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errorObj.loaiCanBoHuongDan}</div>}
                                                                                    </Form.Group>
                                                                                </Col>
                                                                            </Row>
                                                                            <Row>
                                                                                <Col md={12}>
                                                                                    <Form.Group>
                                                                                        <Form.Label>Đơn vị công tác <span className="text-danger">*</span></Form.Label>
                                                                                        <Form.Control
                                                                                            type="text"
                                                                                            name={`chiTietThayDoiCBHDs.${index}.donViCongTac`}
                                                                                            value={cbhd.donViCongTac}
                                                                                            onChange={handleChange}
                                                                                            onBlur={handleBlur}
                                                                                            placeholder="Nhập đơn vị công tác"
                                                                                            disabled={viewMode === 'view'} className={viewMode === 'view' ? "bg-white" : ""}
                                                                                        />
                                                                                        {touchedObj && touchedObj.donViCongTac && errorObj && errorObj.donViCongTac && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errorObj.donViCongTac}</div>}
                                                                                    </Form.Group>
                                                                                </Col>
                                                                            </Row>
                                                                            <Row>
                                                                                <Col md={6} className="mb-3">
                                                                                    {viewMode === 'view' ? (
                                                                                        <FieldDisplayFile label={<span>File lý lịch Cán bộ hướng dẫn <span className="text-danger">*</span></span>} value={cbhd.fileLyLichKhoaHoc} />
                                                                                    ) : (
                                                                                        <DocumentInput
                                                                                            labelTitle={<span>File lý lịch Cán bộ hướng dẫn <span className="text-danger">*</span></span>}
                                                                                            value={cbhd.fileLyLichKhoaHoc}
                                                                                            onChangeProp={(url) => setFieldValue(`chiTietThayDoiCBHDs.${index}.fileLyLichKhoaHoc`, url)}
                                                                                            readOnly={viewMode === 'view'}
                                                                                        />
                                                                                    )}
                                                                                    {submitCount > 0 && errorObj && errorObj.fileLyLichKhoaHoc && !cbhd.fileLyLichKhoaHoc && (
                                                                                        <div className="text-danger small mt-1">{errorObj.fileLyLichKhoaHoc}</div>
                                                                                    )}
                                                                                </Col>
                                                                                <Col md={6} className="mb-3">
                                                                                    {viewMode === 'view' ? (
                                                                                        <FieldDisplayFile label={<span>File minh chứng Cán bộ hướng dẫn <span className="text-danger">*</span></span>} value={cbhd.fileMinhChung} />
                                                                                    ) : (
                                                                                        <DocumentInput
                                                                                            labelTitle={<span>File minh chứng Cán bộ hướng dẫn <span className="text-danger">*</span></span>}
                                                                                            value={cbhd.fileMinhChung}
                                                                                            onChangeProp={(url) => setFieldValue(`chiTietThayDoiCBHDs.${index}.fileMinhChung`, url)}
                                                                                            readOnly={viewMode === 'view'}
                                                                                        />
                                                                                    )}
                                                                                    {submitCount > 0 && errorObj && errorObj.fileMinhChung && !cbhd.fileMinhChung && (
                                                                                        <div className="text-danger small mt-1">{errorObj.fileMinhChung}</div>
                                                                                    )}
                                                                                </Col>
                                                                            </Row>
                                                                    </div>
                                                                );
                                                            })
                                                        ) : (
                                                            <div className="text-center p-3 border rounded text-muted">Chưa có Cán bộ hướng dẫn nào. Vui lòng thêm.</div>
                                                        )}
                                                        {viewMode !== 'view' && (
                                                            <BootstrapButton type="button" variant="outline-primary" size="sm" onClick={() => arrayHelpers.push({ hoTen: '', loaiCanBoHuongDan: null, donViCongTac: '', fileLyLichKhoaHoc: '', fileMinhChung: '' })}>
                                                                <i className="fas fa-plus mr-1"></i> Thêm Cán bộ hướng dẫn
                                                            </BootstrapButton>
                                                        )}
                                                    </div>
                                                )}
                                            />
                                        </Col>
                                    </Row>
                                </>
                            )}
                            
                            {values.loaiYeuCau === loaiYeuCauValue.giaHanDaoTao && (
                                <>
                                    <Row>
                                        <Col md={12}>
                                            <Form.Group>
                                                <Form.Label>Thời gian gia hạn (tháng) <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    name="thoiGianGiaHan"
                                                    value={values.thoiGianGiaHan}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    placeholder="Nhập thời gian gia hạn"
                                                    disabled={viewMode === 'view'} className={viewMode === 'view' ? "bg-white" : ""}
                                                />
                                                {touched.thoiGianGiaHan && !!errors.thoiGianGiaHan && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.thoiGianGiaHan}</div>}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12} className="mb-3">
                                            {viewMode === 'view' ? (
                                                <FieldDisplayFile label={<span>File công văn của đơn vị công tác, đồng ý cho phép gia hạn <span className="text-danger">*</span></span>} value={values.fileCongVan} />
                                            ) : (
                                                <DocumentInput
                                                    labelTitle={<span>File công văn của đơn vị công tác, đồng ý cho phép gia hạn <span className="text-danger">*</span></span>}
                                                    value={values.fileCongVan}
                                                    onChangeProp={(url) => setFieldValue('fileCongVan', url)}
                                                    readOnly={viewMode === 'view'}
                                                />
                                            )}
                                            {submitCount > 0 && errors.fileCongVan && !values.fileCongVan && (
                                                <div className="text-danger small mt-1">{errors.fileCongVan}</div>
                                            )}
                                        </Col>
                                        <Col md={12} className="mb-3">
                                            {viewMode === 'view' ? (
                                                <FieldDisplayFile label={<span>File báo cáo tiến độ thực hiện đề tài luận án (có xác nhận bộ môn, CBHD) <span className="text-danger">*</span></span>} value={values.fileBaoCao} />
                                            ) : (
                                                <DocumentInput
                                                    labelTitle={<span>File báo cáo tiến độ thực hiện đề tài luận án (có xác nhận bộ môn, CBHD) <span className="text-danger">*</span></span>}
                                                    value={values.fileBaoCao}
                                                    onChangeProp={(url) => setFieldValue('fileBaoCao', url)}
                                                    readOnly={viewMode === 'view'}
                                                />
                                            )}
                                            {submitCount > 0 && errors.fileBaoCao && !values.fileBaoCao && (
                                                <div className="text-danger small mt-1">{errors.fileBaoCao}</div>
                                            )}
                                        </Col>
                                    </Row>
                                </>
                            )}
                        </div>
                    );

                    return (
                    <Form onSubmit={handleSubmit}>
                        {viewMode === 'view' ? (
                            <Tabs defaultActiveKey="chiTiet" id="yeu-cau-thay-doi-tabs" className="custom-tabs px-3 pt-3 border-bottom-0">
                                <Tab eventKey="chiTiet" title={<span className="font-weight-bold">Chi tiết yêu cầu</span>}>
                                    {formContent}
                                </Tab>
                                {selectedItem?.loaiYeuCau === loaiYeuCauValue.thayDoiDeTai && 
                                    [trangThaiGuiKetQuaValue.daGui, 'DaGui'].includes(selectedItem?.danhGiaDeTaiData?.trangThaiGuiKetQua || selectedItem?.danhGiaDeTaiData?.TrangThaiGuiKetQua)
                                     && (
                                    <Tab eventKey="ketQua" title={<span className="font-weight-bold">Kết quả đánh giá</span>}>
                                        <div className="p-3">
                                            <DanhGiaDeTaiForm thayDoiDeTaiId={selectedItem?.detailInfo?.id || selectedItem?.chiTietId} readOnly={true} isUserView={true} />
                                        </div>
                                    </Tab>
                                )}
                                {selectedItem?.loaiYeuCau === loaiYeuCauValue.thayDoiCBHD && 
                                    [trangThaiGuiKetQuaValue.daGui, 'DaGui'].includes(selectedItem?.danhGiaCBHDData?.trangThaiGuiKetQua || selectedItem?.danhGiaCBHDData?.TrangThaiGuiKetQua)
                                     && (
                                    <Tab eventKey="ketQua" title={<span className="font-weight-bold">Kết quả đánh giá</span>}>
                                        <div className="p-3">
                                            <DanhGiaCBHDForm thayDoiCBHDId={selectedItem?.detailInfo?.id || selectedItem?.chiTietId} readOnly={true} isUserView={true} />
                                        </div>
                                    </Tab>
                                )}
                                {selectedItem?.loaiYeuCau === loaiYeuCauValue.giaHanDaoTao && 
                                    [trangThaiGuiKetQuaValue.daGui, 'DaGui'].includes(selectedItem?.danhGiaGiaHanData?.trangThaiGuiKetQua || selectedItem?.danhGiaGiaHanData?.TrangThaiGuiKetQua)
                                     && (
                                    <Tab eventKey="ketQua" title={<span className="font-weight-bold">Kết quả đánh giá</span>}>
                                        <div className="p-3">
                                            <DanhGiaGiaHanForm giaHanDaoTaoId={selectedItem?.detailInfo?.id || selectedItem?.chiTietId} readOnly={true} isUserView={true} />
                                        </div>
                                    </Tab>
                                )}
                            </Tabs>
                        ) : (
                            formContent
                        )}
                        <div className="card-footer bg-white border-top-0 d-flex justify-content-end px-3 pb-3">
                            <BootstrapButton variant="secondary" onClick={handleClose} className="mr-2">Đóng</BootstrapButton>
                            {viewMode !== 'view' && (
                                <BootstrapButton variant="primary" type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                            Đang lưu...
                                        </>
                                    ) : 'Lưu'}
                                </BootstrapButton>
                            )}
                        </div>
                    </Form>
                    );
                }}
            </Formik>
            </FormWrapper>
                )}
            </Card>

            <ConfirmModal
                isOpen={openConfirmDeleteModal}
                confirmType="delete"
                handleAccept={handleDeleteYeuCau}
                handleCancel={() => {
                    setOpenConfirmDeleteModal(false);
                    setItemToDelete(null);
                }}
                content="Yêu cầu thay đổi này không"
            />

            <ConfirmModal
                isOpen={openConfirmSendModal}
                handleAccept={handleSendYeuCau}
                handleCancel={() => {
                    setOpenConfirmSendModal(false);
                    setItemToSend(null);
                }}
                content="Bạn có chắc chắn muốn gửi yêu cầu thay đổi này đi để xét duyệt không?"
                labelAccept="Gửi đi"
            />
        </div>
    );
};

export default YeuCauThayDoi;